import Component from 'components/pages/TermsAndConditions/TermsAndConditions';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  metaData: {
    title: 'Terms and Conditions',
    description:
      'The terms and conditions of our service, information about us, and service availability.',
  },
});
